import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import React from 'react';

export const NoopIcon = () => <span />;
export const UpwardIcon = () => <ArrowUpwardIcon sx={{ color: 'green' }} />;
export const DownwardIcon = () => <ArrowDownwardIcon sx={{ color: 'red' }} />;
